import { getCreditReport, runQuotationCreditSearch } from '../api/checks'
import type { Resolvers } from '../generated/server/resolvers'

const CreditReportResolvers: Resolvers = {
  Query: {
    creditReport: async (_, { useClientApi, clientId, documentId }) => {
      return await getCreditReport(useClientApi, clientId, documentId)
    },
  },
  Mutation: {
    runQuotationCreditSearch: async (_, { clientIds }) => {
      return await runQuotationCreditSearch(clientIds)
    },
  },
}

export default CreditReportResolvers
